import usdc from "../../images/usdc.png";
import eth from "../../images/eth-token.png";
import dai from "../../images/dai.png";
import uni from "../../images/uni.png";

export const uniToken = {
  tokenSymbol: "UNI",
  tokenFullName: "UNI",
  tokenDecimal: 18,
  tokenIcon: uni,
  // tokenAddress: isProduction ? "" : goerToken.UNI,
};

export const wethToken = {
  tokenSymbol: "WETH",
  tokenFullName: "WETH",
  tokenDecimal: 18,
  tokenIcon: eth,
  // tokenAddress: isProduction ? arbToken.WETH : goerToken.WETH,
};

export const usdcToken = {
  tokenSymbol: "USDC",
  tokenFullName: "USDC",
  tokenDecimal: 6,
  tokenIcon: usdc,
  // tokenAddress: isProduction ? arbToken.USDC : "",
};

export const daiToken = {
  tokenSymbol: "DAI",
  tokenFullName: "DAI",
  tokenDecimal: 18,
  tokenIcon: dai,
  // tokenAddress: isProduction ? "" : goerToken.DAI,
};
